<template>
	<ms-popup
		:active.sync="active"
		placement="right"
		@close="closePopup"
		animation="right-to-left"
		:helpBtn="false"
	>
		<template slot="header">
			<div class="title">Trợ giúp</div>
			<div class="flex justify-between">
				<div @click="back">
					<span class="text-btn" v-if="isVisiabledBack">Quay lại</span>
				</div>
				<div @click="openOtherTab">
					<span class="text-btn">Mở trên tab khác</span>
				</div>
			</div>
			<div class="search">
				<ms-input
					placeholder="Tìm kiếm thông tin trợ giúp"
					@change="search"
					v-model="searchValue"
				></ms-input>
			</div>
		</template>
		<template slot="content">
			<div ref="content" class="frame-content"></div>
			<div class="loading" v-if="!isLoaded">
				<div class="effect-1 effects"></div>
			</div>
		</template>
	</ms-popup>
</template>
<script>
export default {
	name: 'helpForm',
	created() {
		document.addEventListener('click', this.linkActive);
	},
	data() {
		return {
			active: false,
			content: null,
			widthx: 600,
			searchValue: null,
			helpId: null,
			url: window.__env.authConfig.linkHelp,
			urlLocal: window.__env.authConfig.linkHelp,
			backStack: [],
			isLoaded: false,
			requestId: 0,
		};
	},
	computed: {
		linkUrl() {
			const me = this;
			return me.buildHelpUrl(me.helpId);
		},
		isVisiabledBack() {
			const me = this;
			if (me.backStack && me.backStack.length > 1) {
				return true;
			}
			return false;
		},
	},
	destroyed() {
		const me = this;
		document.removeEventListener('click', this.linkActive);
	},
	methods: {
		back() {
			const me = this;
			if (me.isVisiabledBack) {
				me.backStack.remove(me.backStack[me.backStack.length - 1]);
				let helpId = me.backStack[me.backStack.length - 1];
				me.callGetTemplate(helpId, true);
			}
		},
		openOtherTab() {
			window.open(this.linkUrl, '_blank');
		},
		//Ghép URL giống HelpController.Get: {linkHelpLocal}{path}, thêm '/' nếu thiếu
		//Dùng urlLocal (cùng-origin proxy) để fetch nội dung không bị CORS
		buildHelpUrl(path) {
			const me = this;
			let result = me.urlLocal;
			if (path) {
				if (!path.startsWith('/')) {
					path = '/' + path;
				}
				result += path;
			}
			return result;
		},
		//GET raw HTML — replicate GetHtmlFromUrl của HelpController; lỗi/khác 200 → rỗng (như server trả string.Empty)
		async fetchHtml(url) {
			try {
				const response = await fetch(url, { method: 'GET' });
				if (response.ok) {
					return await response.text();
				}
			} catch (e) {
				//Lỗi mạng/proxy — trả rỗng, không crash
			}
			return '';
		},
		async linkActive(event) {
			const me = this;
			event.preventDefault();

			let url = null;
			if (event.target.href || event.target.closest('a')) {
				url = event.target.href || event.target.closest('a').href;
			} else {
				let _linkTarget = event.target.closest('.hkb-article__link');
				if (_linkTarget) {
					url = _linkTarget.href;
				}
			}
			if (url) {
				//Xóa link local hoặc link help để gọi api lấy nội dung
				let helpId = url.replace(location.origin, '').replace(me.url, '');

				//Kiểm tra xem có phải link help không
				//Nếu không phải link help thì mở ra 1 cửa số mới
				if (helpId.includes('http://') || helpId.includes('https://')) {
					window.open(helpId, '_blank');
				} else {
					me.callGetTemplate(helpId, false);
				}
			}
		},
		async search(value) {
			const me = this;
			const requestId = ++me.requestId;
			me.isLoaded = false;
			//Giống HelpController.Search: {linkHelpLocal}/?s={query.TrimExt()}&ht-kb-search=1&lang=
			const html = await me.fetchHtml(
				me.urlLocal + '/?s=' + encodeURIComponent(value.trim()) + '&ht-kb-search=1&lang='
			);
			if (requestId !== me.requestId) {
				return;
			}
			me.buildContent(html);
			me.isLoaded = true;
		},
		async callGetTemplate(helpId, isBack) {
			const me = this;
			me.helpId = helpId;

			if (!isBack) {
				me.backStack.push(me.helpId);
			}

			const requestId = ++me.requestId;
			me.isLoaded = false;
			//Giống HelpController.Get: {linkHelpLocal}{path}
			const html = await me.fetchHtml(me.buildHelpUrl(helpId));
			if (requestId !== me.requestId) {
				return;
			}
			me.buildContent(html);
			me.isLoaded = true;
		},
		async showPopup(options) {
			const me = this;
			me.active = true;
			me.backStack.removeAll();
			me.callGetTemplate(options.helpId, false);
		},
		buildContent(html) {
			const me = this;
			if (html) {
				let htmlObject = document.createElement('div');
				htmlObject.innerHTML = html;
				let title = htmlObject.querySelector('.hkb-article__title');
				let sitecontainer = htmlObject.querySelector('.ht-sitecontainer');
				let content = htmlObject.querySelector('.hkb-article__content');
				if (sitecontainer) {
					let imgList = sitecontainer.querySelectorAll('img');
					if (imgList && imgList.length > 0) {
						imgList.forEach((item) => {
							let src = item.getAttribute('data-cfsrc') || item.src;
							if (src.includes(location.origin)) {
								src = src.replace(location.origin, me.url);
							} else {
								if (!src.includes(me.url)) {
									src = me.url + src;
								}
							}
							item.removeAttribute('data-cfsrc');
							item.removeAttribute('srcset');
							item.setAttribute('src', src);
							item.style.display = '';
							item.style.visibility = '';
						});
					}
				}
				if (content) {
					if (title) {
						title.innerText = title.innerText.substr(
							title.innerText.indexOf('.') + 1,
							title.innerText.length
						);
					}
					sitecontainer.innerHTML = title.outerHTML + content.outerHTML;
				} else {
					let list = htmlObject.querySelector('.ht-page__content');
					let categoryTitle = list.querySelector('.ht-categoryheader__title');
					if (categoryTitle) {
						categoryTitle.innerText = categoryTitle.innerText.substr(
							categoryTitle.innerText.indexOf('.') + 1,
							categoryTitle.innerText.length
						);
					}
					sitecontainer.innerHTML = list.outerHTML;
				}

				if (me.$refs.content.querySelector('.ht-sitecontainer')) {
					me.$refs.content.querySelector('.ht-sitecontainer').innerHTML =
						sitecontainer.innerHTML;
				} else {
					me.$refs.content.append(sitecontainer);
				}

				//Cuộn lên đầu trang
				me.$el.querySelector('.popup-content').scrollTop = 0;
			}
		},
		closePopup() {
			const me = this;
			me.active = false;
			me.searchValue = null;
			document.removeEventListener('click', this.linkActive);
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/help.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/help.scss';
}
</style>
<style lang="scss">
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/help.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/help.scss';
}
</style>
